import React from 'react';
import classNames from 'classnames';
import Menu from '@components/core/Menu';
import Button from '@components/legacy/core/Button';
import Tooltip from '@components/core/Tooltip';
import './AddAutomationMenu.less';
import { useTranslations } from '@components/context';

const AddAutomationTriggerButton = ({ addButtonLabel, disabled }) => (
    <Button type="link" className="add-automation-menu__trigger-btn" disabled={disabled}>
        <span className="icon-svg-plus add-automation-menu__trigger-plus-icon" aria-hidden />
        <span>{addButtonLabel}</span>
    </Button>
);

/**
 * "Add automation" control: the Design System menu (core/Menu, portalled) behind the flow
 * editor's link-style trigger. Disabled it renders the trigger alone, with the reason in a
 * tooltip.
 */
const AddAutomationMenu = ({
    className,
    actions,
    onSelect,
    addButtonLabel,
    disabled = false,
    disabledTooltip,
}) => {
    const { t } = useTranslations();
    const buttonLabel = addButtonLabel || t('Add automation');
    if (disabled) {
        const trigger = (
            <AddAutomationTriggerButton addButtonLabel={buttonLabel} disabled />
        );
        return (
            <div className={classNames('add-automation-menu', 'add-automation-menu--disabled', className)}>
                {disabledTooltip ? <Tooltip title={disabledTooltip}>{trigger}</Tooltip> : trigger}
            </div>
        );
    }

    return (
        <Menu
            className={classNames('add-automation-menu', className)}
            align="left"
            trigger={<AddAutomationTriggerButton addButtonLabel={buttonLabel} />}
            menuClassName="add-automation-menu__dropdown-shell"
            itemClassName="add-automation-menu__dropdown-item"
            showSelectedIcon={false}
            items={(actions || []).map((action) => ({
                id: action.id,
                label: action.name || action.label,
                icon: action.icon,
                onSelect: () => onSelect(action),
            }))}
        />
    );
};

export default AddAutomationMenu;
